module.exports = __webpack_public_path__ + "img/phone.e1a82804.svg";